import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import GallerySection from '../components/GallerySection';
import ContactForm from '../components/ContactForm';

export default function PrivateCleaning() {
  const kitchenImg = 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/3c7718da-c622-4e09-b9ce-f749a5967f74/private-cleaning-kitchen.png';
  const bathImg = 'https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/3c7718da-c622-4e09-b9ce-f749a5967f74/private-cleaning-bathroom.png';

  return (
    <div>
      <SEO
        title="Privat rengøring - Power-Multiservice"
        description="Fleksibel og grundig privatrengøring tilpasset dit hjem. Faste aftaler eller enkeltstående hovedrengøring i Nørre Aaby og omegn."
        path="/privat-rengoering"
      />

      {/* HERO SECTION */}
      <section className="bg-white py-12 sm:py-20 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            
            <div className="lg:col-span-7 space-y-6 text-center lg:text-left animate-fade-in-up">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight">
                Grundig og pålidelig rengøring til dit private hjem
              </h1>

              <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
                Få mere tid og overskud i hverdagen med en fast rengøringsaftale eller hjælp til enkeltstående hovedrengøring. Vi behandler dit hjem med respekt, omhu og stor grundighed.
              </p>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center lg:justify-start gap-3 sm:gap-4 pt-2">
                <Link
                  to="/prisberegner"
                  className="group px-7 py-3.5 rounded-full font-bold text-sm sm:text-base text-slate-950 bg-emerald-400 hover:bg-emerald-300 hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <i className="fa-solid fa-calculator text-sm group-hover:rotate-12 transition-transform duration-300" aria-hidden="true" />
                  <span>Beregn din pris</span>
                </Link>

                <a
                  href="#tilbud-formular"
                  className="group px-6 py-3.5 rounded-full font-bold text-sm sm:text-base text-black bg-transparent hover:bg-slate-50 border border-black hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <span>Få et tilbud</span>
                  <i className="fa-solid fa-arrow-down text-black text-xs group-hover:translate-y-0.5 transition-transform duration-200" aria-hidden="true" />
                </a>
              </div>
            </div>

            <div className="lg:col-span-5 animate-fade-in-up delay-100">
              <div className="group overflow-hidden">
                <img
                  src={kitchenImg}
                  alt="Spotless køkken i privat bolig"
                  className="w-full h-80 sm:h-96 object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* HVAD VI TILBYDER I PRIVAT RENGØRING */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              Hvad kan vi hjælpe dig med?
            </h2>
            <p className="mt-3 text-slate-600 text-base">
              Vi tilpasser altid opgaven efter din bolig og dine ønsker.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
            <div className="bg-white border border-slate-100 shadow-md p-6 sm:p-8 flex flex-col justify-between">
              <div>
                <div className="text-black text-3xl mb-5">
                  <i className="fa-solid fa-kitchen-set text-black" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3">Køkken & Badeværelse</h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  Dybdegående rengøring af de vigtigste rum i huset:
                </p>
                <ul className="space-y-2 text-xs sm:text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Aftørring af bordplader, armatur og vask</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Afkalkning af bruseniche og fliser</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Rengøring af toilet og spejle</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white border border-slate-100 shadow-md p-6 sm:p-8 flex flex-col justify-between">
              <div>
                <div className="text-black text-3xl mb-5">
                  <i className="fa-solid fa-broom text-black" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3">Stuer & Værelser</h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  Friske, støvfrie og indbydende opholdsrum:
                </p>
                <ul className="space-y-2 text-xs sm:text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Grundig støvsugning af alle gulve og tæpper</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Gulvvask med skånsomme, velegnede sæber</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Aftørring af tilgængelige overflader</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white border border-slate-100 shadow-md p-6 sm:p-8 flex flex-col justify-between">
              <div>
                <div className="text-black text-3xl mb-5">
                  <i className="fa-solid fa-calendar-days text-black" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3">Fleksible Intervaller</h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  Vi sammensætter aftalen efter dit tempo:
                </p>
                <ul className="space-y-2 text-xs sm:text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Ugentlig fast rengøring</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Rengøring hver 14. dag eller månedligt</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Hovedrengøring eller før-/efterfester</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* DYNAMISK CMS GALLERI FOR PRIVAT RENGØRING */}
      <GallerySection
        slug="privat-rengoering"
        title="Privat galleri"
        subtitle="Billeder af vores privatrengøring"
      />

      {/* KONTAKTFORMULAR SEKTION */}
      <section id="tilbud-formular" className="py-16 sm:py-20 bg-white border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            
            {/* Kontaktoplysninger i venstre side */}
            <div className="lg:col-span-5 space-y-6 text-left">
              <div>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                  Direkte kontakt for private
                </h2>
                <p className="text-slate-600 text-sm sm:text-base mt-2 leading-relaxed">
                  Har du spørgsmål til en fast aftale i dit hjem eller en enkeltstående hovedrengøring? Ring eller skriv direkte til os.
                </p>
              </div>

              <div className="space-y-4 pt-2">
                <a
                  href="tel:31686764"
                  className="flex items-center gap-4 text-slate-900 hover:text-emerald-700 transition-colors group"
                >
                  <i className="fa-solid fa-phone text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold whitespace-nowrap">31 68 67 64</div>
                </a>

                <a
                  href="mailto:zokimaretic@gmail.com"
                  className="flex items-center gap-4 text-slate-900 hover:text-emerald-700 transition-colors group"
                >
                  <i className="fa-solid fa-envelope text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold whitespace-nowrap">zokimaretic@gmail.com</div>
                </a>

                <div className="flex items-center gap-4 text-slate-900">
                  <i className="fa-solid fa-location-dot text-black text-lg" aria-hidden="true" />
                  <div className="text-base font-bold">Idrætsvej 1, 5580 Nørre Aaby</div>
                </div>
              </div>

              <div className="pt-4 border-t border-slate-200">
                <ul className="space-y-2 text-sm text-slate-700">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Uforpligtende tilbud på din bolig</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Hurtigt svar og fleksible tider</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-black" aria-hidden="true" />
                    <span>Pålidelig rengøring med respekt for hjemmet</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Formular i højre side */}
            <div className="lg:col-span-7">
              <ContactForm
                heading="Få et uforpligtende tilbud på privat rengøring"
                initialData={{ serviceType: 'privat' }}
              />
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}
